import { SelectionItem } from "../../models/selection_item";
import BaseApiService from "../base_api.service";

export class GroupClaimService extends BaseApiService {
  /**
   *
   */
  constructor() {
    super("group-claims");
  }

  async getByGroupId(id: string): Promise<SelectionItem[]> {
    const response = await this.get<SelectionItem[]>(`/groups/${id}`);
    return response ?? [];
  }
  add(
    operationClaimList: string[],
    groupId: string,
  ): Promise<string | undefined> {
    return this.post<string>(``, {
      operationClaims: operationClaimList,
      groupId: groupId,
    });
  }
  deleted(claimIds: string[], groupId: string): Promise<string | undefined> {
    console.error(groupId);

    return this.post<string>(`DeleteList`, { claimIds, groupId });
  }
}
